import React from 'react';
import { graphql } from 'gatsby';

import Button from '../components/Button';
import Hero from '../components/Hero';
import USPCard from '../components/USPCard';
import IconContentBlock from '../components/IconContentBlock';
import Heading from '../components/renderers/Heading';
import AnchorNav from '../components/AnchorNav';
import Section from '../components/Section';
import { DefaultLogoReel } from '../components/LogoReel';

const sectionItems = [
  {
    slug: 'technical',
    title: 'Technical',
  },
  {
    slug: 'editorial-and-operational',
    title: 'Editorial & Operational',
  },
];

const features = [
  {
    icon: 'GRAPHQL',
    title: 'Headless GraphQL CMS',
    description:
      'Blazing fast GraphQL content API with query and mutation support.',
  },
  {
    icon: 'GLOBE',
    title: 'Smart Edge Cache',
    description:
      'Cache your query responses across 190 edge POPs around the world.',
  },
  {
    icon: 'WRENCH',
    title: 'Start building for free',
    description:
      "GraphCMS's developer tier is free forever. Start building today.",
  },
];

const FeaturesBaseTemplate = ({
  data: { technicalFeatures, nonTechnicalFeatures },
  pageContext: { page },
}) => {
  if (!page) return null;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page} alignment="left">
          <Button
            href="/contact"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Contact Sales for a demo &#8594;
          </Button>
        </Hero>
      </Section>
      <DefaultLogoReel className="mb-16 md:mb-24" />
      <Section colour="dark">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map(USPCard)}
        </div>
      </Section>
      <Section>
        <AnchorNav items={sectionItems} />

        {sectionItems.map((item) => (
          <React.Fragment key={item.slug}>
            <div className="mb-16 text-center" id={item.slug}>
              <Heading level={2} name={item.slug}>
                {item.title}
              </Heading>
              <hr className="inline-block bg-cornflower border-0 h-1 rounded w-24 md:w-48" />
            </div>

            <div className="md:flex md:flex-wrap -mx-6">
              {item.slug === 'technical'
                ? technicalFeatures.nodes.map(IconContentBlock)
                : nonTechnicalFeatures.nodes.map(IconContentBlock)}
            </div>
          </React.Fragment>
        ))}
      </Section>
    </React.Fragment>
  );
};

export const query = graphql`
  query featuresPageQuery {
    technicalFeatures: allGraphCmsFeature(filter: { type: { eq: TECHNICAL } }) {
      nodes {
        id
        title
        description
        ctaTo
        icon
        comingSoon
      }
    }

    nonTechnicalFeatures: allGraphCmsFeature(
      filter: { type: { eq: EDITORIAL_AND_OPERATIONAL } }
    ) {
      nodes {
        id
        title
        description
        ctaTo
        icon
        comingSoon
      }
    }
  }
`;

export default FeaturesBaseTemplate;
